module.exports = __webpack_public_path__ + "img/Lot14.35fec16c.jpg";